export default "__VITE_ASSET__BMeqAgqn__"